import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

function TabContainer({ children, dir }) {
    return (
        <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

const styles = {
    root: {
        flexGrow: 1,
    },
};


class CenteredTabs extends React.Component {
    state = {
        value: "detail"
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    render() {
        const { classes, DetailsComponent, NotesComponent, AttachmentsComponent, openRequestContactModal, isTermSheetOpen, authentication,
            loanId, notes, postNote, putNote, deleteNote,deal,
            attachments, isLoading, PutAttachment, PostAttachment, DeleteAttachment } = this.props;

        return (
            <Paper className={classes.root}>
                <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Detail" value="detail" />
                    <Tab label="Notes" value="notes" />
                    <Tab label="Attachments" value="attachments" />
                </Tabs>
                <div>
                    {this.state.value === "detail" &&
                        <TabContainer>
                            {<DetailsComponent
                                handleOpenRequestContactModal={openRequestContactModal}
                                isTermSheetOpen={isTermSheetOpen}
                                deal={deal} />}
                        </TabContainer>}
                    {this.state.value === "notes" && loanId &&
                        <TabContainer>
                            {<NotesComponent
                                authentication={authentication}
                                postNote={postNote}
                                putNote={putNote}
                                deleteNote={deleteNote}
                                loanId={loanId}
                                notes={notes} />}
                        </TabContainer>}
                    {this.state.value === "attachments" && loanId &&
                        <TabContainer>
                            {<AttachmentsComponent
                                loanId={loanId}
                                authentication={authentication}
                                attachments={attachments}
                                isLoading={isLoading}
                                loanPutAttachment={PutAttachment}
                                loanPostAttachment={PostAttachment}
                                loanDeleteAttachment={DeleteAttachment} />}
                        </TabContainer>}
                </div>
            </Paper>
        );
    }
}

CenteredTabs.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CenteredTabs);



